import { createContext, useContext } from 'react'

import { SprField, SprFieldEventType, SprInputProperties, SprNumberFormat } from './types'

export type FieldEventCallback = (
  type: SprFieldEventType,
  activeEl: SprField,
  inputProperties: SprInputProperties,
) => void

export interface ContextInterface {
  /** Unique form ID */
  formId?: string
  onField(field: SprField, callback: FieldEventCallback): void
  setFieldType(field: SprField, type: 'number' | 'text' | 'tel'): void
  setLabel(field: SprField, label: string): void
  setNumberFormat(format: SprNumberFormat): void
  setPlaceholder(field: SprField, placeholder: string): void
  setStyle(field: SprField, style: string): void
  /** Function that is called to create a token */
  tokenizeCreditCard: () => void
  transferFocus(field: SprField): void
}

export const Context = createContext<ContextInterface>({
  formId: '',
  onField: () => {},
  setFieldType: () => {},
  setLabel: () => {},
  setNumberFormat: () => {},
  setPlaceholder: () => {},
  setStyle: () => {},
  tokenizeCreditCard: () => {},
  transferFocus: () => {},
})

export const useSpreedlyPayment = (): ContextInterface => useContext(Context)
